import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=1a0b5418&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=1a0b5418&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b5418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0b5418')) {
      api.createRecord('1a0b5418', component.options)
    } else {
      api.reload('1a0b5418', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=1a0b5418&scoped=true", function () {
      api.rerender('1a0b5418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/Result.vue"
export default component.exports